<template>
    <BaseButton theme="danger" :disabled="isDeleting" @click="open = true">{{ t("demoAccounts.delete.button") }}</BaseButton>
    <ConfirmationDialog
        v-model:open="open"
        :title="t('demoAccounts.delete.title', { name: label })"
        :text="t('demoAccounts.delete.description')"
        :confirm-label="isDeleting ? t('demoAccounts.delete.deleting') : t('demoAccounts.delete.button')"
        confirm-theme="danger"
        :confirm-disabled="isDeleting"
        :cancel-disabled="isDeleting"
        :close-on-confirm="false"
        @confirm="confirm">
        <template #content>
            <p role="alert" class="body-small text-ink-muted empty:sr-only">{{ errorMessage }}</p>
            <p role="status" class="body-small text-ink-muted empty:sr-only">{{ isDeleting ? t("demoAccounts.delete.progress") : "" }}</p>
        </template>
    </ConfirmationDialog>
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import ConfirmationDialog from "~vue/components/ConfirmationDialog.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { url, label } = defineProps<{ url: string; label: string }>();
const emit = defineEmits<{ deleted: []; deleting: [value: boolean] }>();
const { t } = useI18n();
const open = ref(false);
const isDeleting = ref(false);
const errorMessage = ref("");

async function confirm() {
    if (isDeleting.value) {
        return;
    }
    errorMessage.value = "";
    isDeleting.value = true;
    emit("deleting", true);
    try {
        const { error } = await useFetch(url).delete();
        if (error.value) {
            errorMessage.value = t("demoAccounts.delete.failed");
        } else {
            open.value = false;
            emit("deleted");
        }
    } finally {
        isDeleting.value = false;
        emit("deleting", false);
    }
}
</script>
